import { isMobileNative } from 'app/utils/web-helpers';

function OnMobileNativeOnly({ children }: { children: React.ReactElement | React.ReactElement[] }) {
  if (!isMobileNative) return null;
  return children;
}

export { OnMobileNativeOnly };
